// extracted by mini-css-extract-plugin
export default {"wrapper":"Team_wrapper__ZW5zQ","cards":"Team_cards__TMfk-","card":"Team_card__EuroE","heading":"Team_heading__cTaTo","cardContent":"Team_cardContent__0jeC+"};